import { Input } from "reactstrap"

export const ESTADOS = ['Aguascalientes','Baja California','Baja California Sur','Campeche','Chiapas','Chihuahua','Ciudad de México','Coahuila de Zaragoza','Colima','Durango','Guanajuato','Guerrero','Hidalgo','Jalisco','México','Michoacán de Ocampo','Morelos','Nayarit','Nuevo León','Oaxaca','Puebla','Querétaro','Quintana Roo','San Luis Potosí','Sinaloa','Sonora','Tabasco','Tamaulipas','Tlaxcala','Veracruz de Ignacio de la Llave','Yucatán','Zacatecas']

export default function EstadosMexico({value, onChange, readOnly}) {

return (
        <Input type="select" className="FormInput"
            value={value}
            onChange={onChange}
            disabled={readOnly}>
                {
                    ESTADOS.map(e => (
                        <option key={e} value={e}>{e}</option>
                    ))
                }
        </Input>
    )

}